module.exports = __webpack_public_path__ + "static/img/carousel_03.0afbc91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel_03.png
// module id = 6dK9
// module chunks = 0